import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=2fc80f78&scoped=true&"
import script from "./Settings.vue?vue&type=script&setup=true&lang=js&"
export * from "./Settings.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc80f78",
  null
  
)

export default component.exports